/*
  Haelt die Zahl in der Kiste im Header aktuell.

  Beim Seitenaufbau und nach jeder Warenkorb-Aenderung rechnet Liquid den
  Wert (nur Liquid sieht die Produkt-Tags) - cart.js rendert dafuer
  #cart-icon-bubble neu. Dieses Skript deckt den Fall ab, den Liquid nicht
  sehen kann: die Auswahl im Builder, die noch gar nicht im Warenkorb ist.

  Wichtig: das Element wird bei JEDEM Aufruf neu gesucht. cart.js ersetzt
  das innerHTML des Symbols, eine einmal gemerkte Referenz waere danach
  ein Knoten, der nicht mehr im Dokument haengt.
*/
(function () {
  'use strict';

  function bump(el) {
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  }

  window.akSetBuildCount = function (n) {
    n = parseInt(n, 10);
    if (isNaN(n)) return;

    var num = document.getElementById('ak-kiste-num');
    if (!num) return;
    if (String(n) === num.textContent) return;

    num.textContent = n;

    var box = num.closest ? num.closest('.ak-kiste') : null;
    var req = box ? parseInt(box.getAttribute('data-required'), 10) || 24 : 24;

    if (box) {
      bump(box);
      /* Voll = die Zahl wird gruen statt rot. Rot ist in dieser Kiste
         eine Aufforderung ("es fehlen noch welche"); ist sie voll, ist
         nichts mehr aufzufordern. Gesetzt wird nur die Klasse, die
         Farbe steht in ak-home-2026.css. */
      box.classList.toggle('is-complete', n >= req);
    }

    var link = document.getElementById('cart-icon-bubble');
    if (link) {
      link.setAttribute('aria-label', n + ' von ' + req + ' Produkten in Ihrer Kiste');
    }
  };

  /* Auf der Builder-Seite fuehrt ein Klick auf die Kiste zur eigenen
     Auswahl-Liste, nicht in den Warenkorb-Drawer: dort liegt die Auswahl
     noch gar nicht drin, der Drawer wuerde also etwas anderes zeigen als
     die Zahl daneben. */
  document.addEventListener('click', function (event) {
    if (typeof window.kbOpenSelection !== 'function') return;
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('#cart-icon-bubble')) return;

    event.preventDefault();
    event.stopPropagation();
    window.kbOpenSelection();
  }, true);
})();
